import { LegalClientBodyType } from 'api/types/entity';
import { FormSubmit } from 'libs/form';
import { TFunc, useTranslation } from 'libs/i18n';
import { DialogStateProps } from 'libs/ui';

import { BodyItem } from '../BodiesInfoCard';

import { FormContent } from './FormContent';
import { BodyFormType, Form, getSchema } from './bodyForm';

interface Props extends DialogStateProps {
  body?: BodyItem;
  submitLoading?: boolean;
  editable?: boolean;
  onSubmit: (
    body: { name: string; type: LegalClientBodyType; otherType?: string },
    reason: string
  ) => void;
}

const getInitialValues = (t: TFunc, body?: BodyItem): BodyFormType =>
  body
    ? {
        type: {
          label: t(`client.legal.companyStructure.bodyTypes.${body.type}`),
          value: body?.type,
        },
        name: body?.name,
        otherType: body?.otherType,
        reason: '',
      }
    : ({} as BodyFormType);

export const BodyDialog = ({
  body,
  isOpen,
  submitLoading,
  editable,
  onClose,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();

  const handleBodySubmit: FormSubmit<BodyFormType> = (values) => {
    const data = {
      name: values.name,
      type: values.type.value,
      otherType: values.otherType,
    };
    onSubmit(data, values.reason);
  };

  return (
    <Form
      key={body?.id}
      initialReadOnly={!editable}
      initialValues={getInitialValues(t, body)}
      validationSchema={schema}
      onSubmit={handleBodySubmit}
    >
      <FormContent
        editable={editable}
        isOpen={isOpen}
        submitLoading={submitLoading}
        onClose={onClose}
      />
    </Form>
  );
};
